import convertOssUrl from "./convertOssUrl.js";

const rotateOssurl = ({ url, orient = "left" }) => {
  const prefix = "?x-oss-process=image/";
  let match = url.match(/rotate,\d+/);
  if (match && match[0]) {
    let degree;
    let originDegree = match[0].replace("rotate,", "");
    originDegree = Number(originDegree);
    if (orient == "left") {
      degree = originDegree - 90 == -360 ? 0 : originDegree - 90;
    } else {
      degree = originDegree + 90 == 360 ? 0 : originDegree + 90;
    }
    url = url.replace(/rotate\,\d*/, "rotate," + degree);
  } else if (!url.includes(prefix)) {
    url = `${url}${prefix}rotate${orient == "left" ? "-90" : "90"}`;
  } else if (url.includes(prefix) && !match) {
    url += `/rotate,${orient == "left" ? "-90" : "90"}`;
  }

  if (!url.includes("auto-orient")) {
    url += "/auto-orient,0";
  }
  return url;
};

export default rotateOssurl;
